// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../../common/JQueryView';
import DateRangePicker from '../../../../common/DateRangePicker';

export default class FormView extends JQueryView {
  establishAt: string;

  constructor(establishAt: string) {
    super('.form-content-wrapper');
    this.establishAt = establishAt;
    this.initDateRangePicker(this.$el);
    this.toggleFormState();
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        minDate: this.establishAt,
        showDropdowns: true,
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  // so_condition_category_idの状態に応じて詳細のフォームを有効化/無効化するメソッド
  toggleFormState() {
    $('.select-so_condition_category').each(function() {
      const conditionCategory = $(this);
      const detailElement = conditionCategory
        .closest('.select-exercise-condition')
        .find('.resolution-content');
      if (conditionCategory.val() === '') {
        detailElement.prop('disabled', true);
      } else {
        detailElement.prop('disabled', false);
      }
    });
  }

  render() {
    this.initDateRangePicker(this.$el);
    this.toggleFormState();
  }

  @on({ event: 'click', selector: '.input-group-append' })
  onClickAppend(event: any) {
    $(event.target)
      .parents('.input-group')
      .children('input,.daterange-picker')
      .focus();
  }

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: any) {
    event.preventDefault();
    $(event.target)
      .prev('input[type=hidden]')
      .val('1');
    $(event.target)
      .closest('fieldset')
      .hide();
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $(event.target).before(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );
    this.toggleFormState();
  }

  @on({ event: 'change', selector: '.select-so_condition_category' })
  async onChangeConditionCategory(event: any) {
    const target = event.target;
    const conditionCategory = $(target);
    const detailElement = conditionCategory
      .closest('.select-exercise-condition')
      .find('.resolution-content');
    if (conditionCategory.val() === '') {
      detailElement.prop('disabled', true);
    } else {
      detailElement.prop('disabled', false);
    }

    const soConditionCategoryId = target.value;
    let inputText = '';

    if (soConditionCategoryId) {
      const res = await this.getSoConditionCategory(soConditionCategoryId);
      inputText = res['detail'];
    }

    detailElement.val(inputText);
  }

  async getSoConditionCategory(soConditionCategoryId: number) {
    const res = await $.ajax({
      url: `/company/share_type_so_exercise_condition_categories/${soConditionCategoryId}`,
      type: 'GET',
    });

    return res;
  }
}
